import { SVGProps, Ref, forwardRef } from 'react';

export const DnrGrayscaleSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.348 1.3v.005c7.14-.106 8.11 2.993 8.11 2.993.768 1.044.676 5.472 0 6.487 0 0-1.459 3.635-8.11 3.657v.01H2.854v-11.2L1 2.53V1.3zm0 11.069V3.357c3.901-.369 4.882 1.986 4.882 1.986a7.03 7.03 0 0 1 0 5.012s-.541 2.507-4.882 2.014"
                fill="#919191"
            />
        </g>
    </svg>
));
DnrGrayscaleSize16Glyph.displayName = 'DnrGrayscaleSize16Glyph';
